import { forwardRef } from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { Grow } from '@mui/material';
import Lottie from 'lottie-react';
import { DialogStyled } from '../DialogStyled';
import { useAtom } from 'jotai';
import { showInstacartRedirectModalAtom } from '../../../store';
import { useTranslation } from 'react-i18next';
import InstacartCarrot from 'src/images/logos/instacart-carrot.svg?react';

import LoadingAnimation from '../../../images/lotties/CTA-cart.json';

export const InstacartRedirectModal = () => {
  const [show] = useAtom(showInstacartRedirectModalAtom);
  const { t } = useTranslation();

  return (
    <DialogStyled
      open={show}
      // Non-dismissible while the IDP request is in flight — navigation
      // away on success, or the send helper clears the atom on failure.
      disableEscapeKeyDown
      onClose={() => undefined}
      TransitionComponent={Transition}
      aria-describedby='instacart-redirect-description'
      customWidth='auto'
      customMinWidth={240}
      customMaxWidth={300}
    >
      <div className='flex flex-col items-center justify-center gap-2 px-4 pb-4 pt-4'>
        <div className='flex h-14 w-14 items-center justify-center rounded-xl bg-white shadow-sm'>
          <InstacartCarrot
            role='img'
            aria-label='Instacart'
            className='h-10 w-auto'
            height={40}
          />
        </div>
        <p
          id='instacart-redirect-description'
          className='text-200 animate-pulse text-center font-semibold text-primary-dark'
        >
          {t('get.opening_instacart')}
        </p>
        <Lottie
          animationData={LoadingAnimation}
          style={{ width: '120px', height: 'auto' }}
        />
      </div>
    </DialogStyled>
  );
};

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Grow ref={ref} {...props} />;
});
